import { useEffect, useState } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import parse from 'html-react-parser'

import InfoPopup from '../InfoPopup';
import Popup from '../Popup';
import InteressensgebieteSelection from './InteressensgebieteSelection';
import MandatoryStar from '../MandatoryStar';
import Spinner from '../Spinner';

import { validateRegistration } from './validation'
import { getURLParameter, sendRequest } from '../Global/functions'
import { cme_kurs } from '../Global/Kurs'
import { supportInfo } from '../Global/constants';

import * as GoogleAnalytics from '../Global/GoogleAnalytics'


const RegistrationForm = ({ jumpToStep, isDoc, newUser, thisUser, setThisUser, answerKey, loginClicksCounter, setLoginClicksCounter, courseAgreement, setCourseAgreement, errorMessage, setErrorMessage, setMailSuccess, nameOfArztID, nameOfArztIDPlaceholder, handleEfnChange, onChange, setFailedCourse, setFinalMessage }) => {

    // -- is loading
    const [loading, setLoading] = useState(false);

    // -- on mount clear .Zustimmung and courseAgreement
    useEffect(() => {
        setThisUser((prev) => ({
            ...prev,
            Zustimmung: 0
        }));
        setCourseAgreement(false);
    }, [])


    // -- on change interessensgebiet
    const changeInterGebi = (interessensgebiet) => {
        const newArr = [...thisUser.Interessensgebiete];
        const index = newArr.indexOf(interessensgebiet);

        // remove
        if (index > -1) newArr.splice(index, 1);
        // add
        else newArr.push(interessensgebiet);

        setThisUser(prev => ({
            ...prev,
            Interessensgebiete: newArr
        }))
    }



    // -- submit Kursteilnahme
    const submitRegistrationForm = async (event) => {
        setLoading(true);
        event.preventDefault();

        try {
            // aussendienst message
            const adSuccessMessage_fullpoints = "Sie haben diesen Kurs mit voller Punktzahl bestanden.<br>Die Teilnahmebestätigung erhalten Sie in Kürze.<br>";
            const adSuccessMessage = "Sie haben diesen Kurs bestanden.<br>Die Teilnahmebestätigung erhalten Sie in Kürze.<br>";

            // no aussendienst message
            const successMessage_fullpoints = "Sie haben diesen Kurs mit voller Punktzahl bestanden.<br>Die Teilnahmebestätigung erhalten Sie per E-Mail.<br>";
            const successMessage = "Sie haben diesen Kurs bestanden.<br>Die Teilnahmebestätigung erhalten Sie per E-Mail.<br>";

            // failure message
            const failureMessage = "Sie haben leider nicht bestanden.<br>Sie können diesen Kurs jederzeit wiederholen.<br>"


            // clear error-message
            setErrorMessage("");

            var confirmationMessage = "";

            // validate input
            if (validateRegistration(event.target, setErrorMessage, thisUser, isDoc)) {

                // append url-parameter if passed by aussendienstler
                var urlParameter = getURLParameter();

                // get ad-infos from url
                const ad_firstname = urlParameter.ad_firstname;
                const ad_lastname = urlParameter.ad_lastname;
                const ad_email = urlParameter.ad_email;

                // build body for request
                const body = {
                    ...thisUser,
                    "VNR": cme_kurs.VNR,
                    "AnswerKey": answerKey,
                    "AD_Vorname": ad_firstname ? ad_firstname : "",
                    "AD_Nachname": ad_lastname ? ad_lastname : "",
                    "AD_Email": ad_email ? ad_email : ""
                }


                // SEND TEILNAHME TO BACKEND
                const response = await sendRequest('POST', '/kursteilnahme/absolviert', body);

                if (response.success) {

                    // response-code from backend { result: X }
                    const responseCode = response.data.result;

                    // mail got successfully sent to teilnehmer
                    const mailingSuccess = response.data.mailingSuccess;
                    setMailSuccess(mailingSuccess);


                    // SUCCESS
                    switch (responseCode) {

                        case 2:
                            // -- passed course with full points                      
                            if (ad_email && ad_firstname && ad_lastname) {
                                // if aussendienstler is managing certificates
                                confirmationMessage = adSuccessMessage_fullpoints;
                            }
                            else {
                                confirmationMessage = successMessage_fullpoints;
                            }

                            finishedRegistration(confirmationMessage);
                            break;

                        case 1:
                            // -- passed course with errors                      
                            if (ad_email && ad_firstname && ad_lastname) {
                                // if aussendienstler is managing certificates
                                confirmationMessage = adSuccessMessage;
                            }
                            else {
                                confirmationMessage = successMessage;
                            }

                            finishedRegistration(confirmationMessage);
                            break;

                        case 0:
                            // failed course
                            confirmationMessage = failureMessage;

                            finishedRegistration(confirmationMessage, true);
                            break;

                        default:
                            throw "Kein responseCode vorhanden";
                    }

                    // done
                    return;
                }
                else { throw "Fehler bei Request" }
            }
        }
        catch (e) {
            console.log("Fehler bei Registrierung", e);
            setErrorMessage(
                `<div>
                    Fehler beim Absenden Ihrer Informationen.
                    <br>
                    Bitte wenden Sie sich an unseren Support unter: 
                    ${supportInfo}
                </div>`
            );
        }

        // finished loading
        setLoading(false);
    }


    // -- finished registration
    function finishedRegistration(message, failed = false) {
        // send registration-request to google-analytics
        const obj = {
            'VNR': cme_kurs.VNR,
            'KursTitel': cme_kurs.KursTitel,
            'KursKey': cme_kurs.KursKey,
            'KursTyp': cme_kurs.KursTyp,
            'Sponsor': cme_kurs.Sponsor_Name,
            'login_click_count': loginClicksCounter + 1
        }
        GoogleAnalytics.sendToGa4('login_click', obj);
        setLoginClicksCounter(loginClicksCounter + 1);

        // set failed-state
        setFailedCourse(failed);

        // go to final step
        jumpToStep(5);

        // set finished-registration-message
        setFinalMessage(message);
    }


    return (

        <form id="registration-form" className="loginHandler-form" onSubmit={submitRegistrationForm}>

            <div className="form-input-container">


                {/* country */}
                <div>
                    <InfoPopup text={`Bitte wählen Sie zunächst ein Land aus um Ihre ${nameOfArztID} einzugeben`} />

                    <label htmlFor="countryInput">Land<sup className="mandatory-field">*</sup></label>
                    <select disabled={thisUser.Land ? true : false} name="countryInput" id="countryInput" form="registration-form" className="form-dropdown-input" value={thisUser.Land ? thisUser.Land : ""} onChange={(e) => onChange(e, "Land")} autoComplete='section-register country-name'>
                        <option value="" disabled hidden>Bitte wählen</option>
                        <option value="Deutschland">Deutschland</option>
                        <option value="Österreich">Österreich</option>
                        <option value="Andere">Andere</option>
                    </select><br />
                </div>


                {/* users efn */}
                <div countryset={(thisUser.Land) ? "true" : "false"}>
                    <label>{nameOfArztID}<sup className="mandatory-field">*</sup></label>
                    <input
                        name="efnInput"
                        type="text"
                        placeholder={nameOfArztIDPlaceholder}
                        value={thisUser.EFN ? thisUser.EFN : ""}
                        onChange={handleEfnChange}

                        // efn got set in login-form -> its always read-only
                        readOnly={true}

                        autoComplete='section-register efn'
                    />
                    <br />
                </div>

                {/* mail */}
                <div>
                    <label>E-Mail<sup className="mandatory-field">*</sup></label>
                    <input name="mailInput" type="mail" placeholder="E-Mail" value={thisUser.Mail ? thisUser.Mail : ""} onChange={(e) => onChange(e, "Mail")} autoComplete='section-register email' /><br />
                </div>

                {/* users title */}
                <div>
                    <label>Titel</label>
                    <input name="titleInput" type="text" placeholder="" value={thisUser.Titel ? thisUser.Titel : ""} onChange={(e) => onChange(e, "Titel")} autoComplete='section-register honorific-prefix' /><br />
                </div>

                {/* users first name */}
                <div>
                    <label>Vorname<sup className="mandatory-field">*</sup></label>
                    <input name="firstnameInput" type="text" placeholder="Ihr Vorname" value={thisUser.Vorname ? thisUser.Vorname : ""} onChange={(e) => onChange(e, "Vorname")} autoComplete='section-register given-name' /><br />
                </div>

                {/* users last name */}
                <div>
                    <label>Nachname<sup className="mandatory-field">*</sup></label>
                    <input
                        name="nameInput"
                        type="text"
                        placeholder="Ihr Nachname"
                        value={thisUser.Nachname ? thisUser.Nachname : ""}
                        onChange={(e) => onChange(e, "Nachname")}
                        autoComplete='section-register family-name'
                    />
                    <br />
                </div>

                {/* street */}
                <div>
                    <label>Straße/Nr<sup className="mandatory-field">*</sup></label>
                    <input name="streetInput" type="text" placeholder="Straße und Hausnr." value={thisUser.Strasse ? thisUser.Strasse : ""} onChange={(e) => onChange(e, "Strasse")} autoComplete='section-register street-address' /><br />
                </div>

                {/* postal */}
                <div>
                    <label>PLZ<sup className="mandatory-field">*</sup></label>
                    <input name="postalInput" type="text" placeholder="Postleitzahl" value={thisUser.Postleitzahl ? thisUser.Postleitzahl : ""} onChange={(e) => onChange(e, "Postleitzahl")} autoComplete='section-register postal-code' /><br />
                </div>

                {/* city */}
                <div>
                    <label>Stadt<sup className="mandatory-field">*</sup></label>
                    <input name="cityInput" type="text" placeholder="Stadt" value={thisUser.Stadt ? thisUser.Stadt : ""} onChange={(e) => onChange(e, "Stadt")} autoComplete='section-register address-level2' /><br />
                </div>

                {/* fachgebiet */}
                <div>
                    <label htmlFor="specialfieldInput">Fachgebiet<sup className="mandatory-field">*</sup></label>
                    <select name="specialfieldInput" id="specialfieldInput" form="registration-form" className="form-dropdown-input" value={thisUser.Fachgebiet ? thisUser.Fachgebiet : ""} onChange={(e) => onChange(e, "Fachgebiet")}>
                        <option value="" disabled hidden>Bitte wählen</option>
                        {cme_kurs.Fachgebiete.map((item, index) => (
                            <option key={"specialfield-" + index} value={item}>{item}</option>
                        ))}
                    </select><br />
                </div>


                {/* place of work */}
                <div className='input-container'>
                    <label id="arbeitsstaette-label">
                        <span>Arbeitsstätte<sup className="mandatory-field">*</sup></span>

                        {/* mehrfachauswahl-info */}
                        <span className='mehrfachauswahl-info'>Mehrfachauswahl möglich</span>
                    </label>

                    <div className='ambulant-stationaer-andere-container'>
                        {/* ambulant */}
                        <div>
                            <input id="register-ambulant-input" name="register-ambulant-input" type="checkbox" value={thisUser.Ambulant ? thisUser.Ambulant : ""} checked={thisUser.Ambulant ? true : false} onChange={(e) => onChange(e, "Ambulant")} />
                            <label htmlFor="register-ambulant-input">Praxis</label>
                        </div>
                        {/* stationaer */}
                        <div>
                            <input id="register-stationaer-input" name="register-stationaer-input" type="checkbox" value={thisUser.Stationaer ? thisUser.Stationaer : ""} checked={thisUser.Stationaer ? true : false} onChange={(e) => onChange(e, "Stationaer")} />
                            <label htmlFor="register-stationaer-input">Klinik</label>
                        </div>
                        {/* andere */}
                        <div>
                            <input id="register-andere-input" name="register-andere-input" type="checkbox" value={thisUser.Andere ? thisUser.Andere : ""} checked={thisUser.Andere ? true : false} onChange={(e) => onChange(e, "Andere")} />
                            <label htmlFor="register-andere-input">Andere</label>
                        </div>
                    </div>
                </div>


                {/* interessensgebiete */}
                <div className="interessensgebiete-container">
                    <label htmlFor="interessensgebiete-input">Interessensgebiete</label>
                    <Popup
                        popupContent={(closePopup) => <InteressensgebieteSelection closePopup={closePopup} thisUser={thisUser} changeInterGebi={changeInterGebi} />}
                        Button={<input name="interessensgebiete-input" className='my-small-btn' type="button" value={"Auswahl"} />}
                        id='interessensgebiete-popup'
                        small={true}
                    />
                    <div className='interessensgebiete-selection small-version no-scrollbar'>
                        {thisUser.Interessensgebiete.map((elem, i) =>
                            <div key={`interessensgebiete-selection-small-key-${i}`} className='single-interessensgebiet active' onClick={() => changeInterGebi(elem)}>
                                {elem} <AiOutlineClose />
                            </div>
                        )}
                    </div>
                </div>


                {/* mandatory agreement */}
                <div className="forCheckbox">
                    <input id="courseAgreementInput" name="courseAgreementInput" type="checkbox" value={courseAgreement} checked={courseAgreement} onChange={() => setCourseAgreement(!courseAgreement)} />
                    <label htmlFor="courseAgreementInput">
                        Hiermit bestätige ich die Richtigkeit meiner Angaben sowie die selbständige Beantwortung der Wissensfragen.<sup className="mandatory-field">*</sup>
                    </label>
                    <br />
                </div>

                {/* newsletter agreement */}
                <div className="forCheckbox">
                    <input id="registerAgreementInput" name="agreementInput" type="checkbox" value={thisUser.Zustimmung ? thisUser.Zustimmung : ""} checked={thisUser.Zustimmung ? true : false} onChange={(e) => onChange(e, "Zustimmung")} />
                    <label htmlFor="registerAgreementInput">
                        Ich bin damit einverstanden, von der Academy Verlagsgesellschaft mbH bzw. der Academy2 GmbH & Co. KG über neue ärztliche Fortbildungsmaßnahmen sowie zu Themen von Arzt und Wirtschaftlichkeit informiert zu werden
                    </label>
                    <br />
                </div>


                {/* red star explanation */}
                <MandatoryStar />


                {/* error messages gonne be displayed here */}
                <div className="error-message">{parse(errorMessage)}</div>

                {!loading ?
                    <input
                        id="submit-registration-btn"

                        // if some input is empty -> submit button is gray
                        className={
                            `my-btn ${(
                                !thisUser.Land ||
                                !thisUser.EFN ||
                                !thisUser.Vorname ||
                                !thisUser.Nachname ||
                                !thisUser.Strasse ||
                                !thisUser.Postleitzahl ||
                                !thisUser.Stadt ||
                                !thisUser.Fachgebiet ||
                                !thisUser.Mail ||
                                !courseAgreement ||
                                (!thisUser.Stationaer && !thisUser.Ambulant && !thisUser.Andere)
                            ) ? "inactive" : ""}`
                        }

                        type="submit"
                        value={(!newUser) ? "Daten senden" : "Registrieren"}
                    />
                    :
                    <Spinner />
                }

            </div>

        </form>
    )
}

export default RegistrationForm